$(window).scroll(function() {    
  var scrollTop = $(window).scrollTop();
  var scroll = 100;
  if (scrollTop >= scroll){
    $('.sk_header__wrapper').addClass('fixed');
  }else{
    $('.sk_header__wrapper').removeClass('fixed');
  }
});
window.onload=function(){
  var div = document.querySelector('#custom__blocks'),
      para = document.querySelectorAll('#custom__blocks .sk__custom_block');
  var paraArr = [].slice.call(para).sort(function (a, b) {
    return a.textContent > b.textContent ? 1 : -1;
  });
  paraArr.forEach(function (p) {
    div.appendChild(p);
  });
}
$('.collection__category_filter-title').click(function(){
  $('.collection__category_filter ul').slideToggle();
});
$('[data-scroll]').on('click',function(e) {
  e.preventDefault();
  var $section = $($(this).attr('href')); 
  $('html, body').animate({
    scrollTop: $section.offset().top - 100
  }, 2000);
});